const WHATSAPP_NUMBER = '+923348872555';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}`;
const PHONE_URL = `tel:${WHATSAPP_NUMBER}`;

export default function StickyCTA() {
  return (
    <>
      {/* Desktop: Floating side CTA */}
      <div className="hidden xl:block fixed bottom-8 right-6 z-40">
        <div className="flex flex-col gap-2">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#d4853a] text-white shadow-lg hover:bg-[#c27630] transition-all duration-300 hover:shadow-xl hover:scale-105"
            aria-label="WhatsApp"
          >
            <i className="ri-whatsapp-line text-xl" />
          </a>
          <a
            href={PHONE_URL}
            className="w-12 h-12 flex items-center justify-center rounded-xl bg-charcoal-300 text-white shadow-lg hover:bg-charcoal-200 transition-all duration-300 hover:shadow-xl hover:scale-105"
            aria-label="Call"
          >
            <i className="ri-phone-line text-lg" />
          </a>
        </div>
      </div>

      {/* Mobile: Bottom bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-t border-ivory-200 shadow-[0_-4px_20px_rgba(0,0,0,0.06)] px-4 py-3 flex items-center gap-2.5">
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 py-3 bg-[#d4853a] text-white text-[13px] font-bold rounded-xl flex items-center justify-center gap-2 transition-all duration-300 active:scale-[0.98]"
        >
          <i className="ri-whatsapp-line text-[16px]" />
          Inquiry
        </a>
        <a
          href={PHONE_URL}
          className="flex-1 py-3 border border-charcoal-200 text-charcoal-300 text-[13px] font-semibold rounded-xl flex items-center justify-center gap-2 transition-all duration-300 active:scale-[0.98]"
        >
          <i className="ri-phone-line text-[15px]" />
          Call Now
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#4a7c59]/10 text-[#4a7c59] shrink-0 transition-all duration-300 active:scale-[0.98]"
          aria-label="Book site visit"
        >
          <i className="ri-car-line text-[16px]" />
        </a>
      </div>
      <div className="md:hidden h-[68px]" />
    </>
  );
}